import store from "@/store";

export const loginGuards = (to, from, next) => {
  if (
    store.getters.isAuthenticated &&
    store.getters.getPermissions.length > 0
  ) {
    const userRoleSlug = store.getters.getUserInfo?.user_role?.slug;
    if (
      userRoleSlug === "sales" ||
      userRoleSlug === "cp" ||
      userRoleSlug === "admin"
    ) {
      next("/dashboard");
    } else if (userRoleSlug === "student") {
      next("/all-application-list");
    } else {
      next();
    }
  } else {
    next();
  }
};

export const salesTeamGuards = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    const userRoleSlug = store.getters.getUserInfo?.user_role?.slug;
    if (
      userRoleSlug === "sales" ||
      userRoleSlug === "cp" ||
      userRoleSlug === "admin"
    ) {
      next();
    } else {
      next("/");
    }
  } else {
    next("/");
  }
};

export const studentGuards = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    const userRoleSlug = store.getters.getUserInfo?.user_role?.slug;
    if (userRoleSlug === "student") {
      next();
    } else {
      next("/");
    }
  } else {
    next("/");
  }
};
